export default __webpack_public_path__ + "static/media/complementary--except-polluting-level-green-yellow-red--g1.36e116eb.png";